import SimLeaderBoard from './SimLeaderBoard';

export default SimLeaderBoard;
